import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { NetworkState } from '../../constants';
import { isDegradedState } from './helpers';

type OfflineState = {
    networkState: NetworkState;
    displayedNetworkState: NetworkState;
    degradedStateStartTimestamp: number | null;
};

const initialState: OfflineState = {
    networkState: NetworkState.ONLINE,
    displayedNetworkState: NetworkState.ONLINE,
    degradedStateStartTimestamp: null,
};

const offlineSlice = createSlice({
    name: 'offline',
    initialState,
    reducers: {
        resetOfflineState() {
            return initialState;
        },
        setNetworkState(state, action: PayloadAction<NetworkState>) {
            const newState = action.payload;

            state.networkState = newState;

            if (isDegradedState(newState) && state.degradedStateStartTimestamp === null) {
                state.degradedStateStartTimestamp = Date.now();
            }

            if (
                isDegradedState(state.displayedNetworkState) &&
                isDegradedState(newState) &&
                newState !== state.displayedNetworkState
            ) {
                state.degradedStateStartTimestamp = Date.now();
            }

            if (newState === NetworkState.ONLINE) {
                state.degradedStateStartTimestamp = null;
            }
        },
        setDisplayedNetworkState(state, action: PayloadAction<NetworkState>) {
            state.displayedNetworkState = action.payload;
        },
    },
});

export const networkStateOnline = createAction('conference/offline/networkStateOnline');
export const networkStateOffline = createAction('conference/offline/networkStateOffline');
export const sdkConnectionOnline = createAction('conference/offline/sdkConnectionOnline');
export const scheduleNetworkStateChange = createAction<NetworkState>('conference/offline/scheduleNetworkStateChange');
export const scheduleReconnectTimeout = createAction('conference/offline/scheduleReconnectTimeout');
export const { resetOfflineState, setNetworkState, setDisplayedNetworkState } = offlineSlice.actions;
export const offlineReducer = offlineSlice.reducer;
